//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SliceZone from 'vue-slicezone'
import { routeTransitionFade } from '@/mixins/route-transitions'

export default {
  components: {
    SliceZone,
  },
  mixins: [routeTransitionFade],
  mounted() {
    this.$app.$emit('page::mounted')
  },
}
